import React from "react";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import TopButton from "../../../components/topButton/TopButton";
import "./Error.css";
import { Link } from "react-router-dom";

export default function Error(props) {
  const theme = props.theme;
  return (
    <div
      className="route-error"
      style={{
        "--error-text": theme.text,
        "--error-muted": theme.secondaryText,
        "--error-accent": theme.imageHighlight,
        "--error-panel": theme.highlight,
      }}
    >
      <Header theme={theme} onToggle={props.onToggle} isDark={props.isDark} />
      <main className="error-stage">
        <div className="error-grid" aria-hidden="true"></div>
        <div className="error-orbit error-orbit-one" aria-hidden="true"></div>
        <div className="error-orbit error-orbit-two" aria-hidden="true"></div>
        <p className="error-kicker">
          <span></span> ROUTE_NOT_FOUND
        </p>
        <div className="error-code" aria-label="404">
          <span>4</span>
          <i>×</i>
          <span>4</span>
        </div>
        <h1>
          That signal
          <br />
          doesn’t exist.
        </h1>
        <p className="error-copy">
          The requested location is outside the observatory. Return to the index
          and choose another transmission.
        </p>
        <Link className="error-home-link" to="/home">
          Return to observatory <span>→</span>
        </Link>
      </main>
      <Footer theme={theme} onToggle={props.onToggle} isDark={props.isDark} />
      <TopButton theme={theme} />
    </div>
  );
}
